module.exports = __webpack_public_path__ + "static/media/m-bg-1.ae63e0d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/m/m-bg-1.png
// module id = 54
// module chunks = 3